import React, { useEffect, useState } from 'react';
import { Table, Modal, Button } from 'antd';

import { getData } from '@util';
import {
  API_POST_SUPPLIER_DATA_LOG_PAGE, // 查询列表
} from '@api';
import RecordForm from './recordForm';

const recordColumns = [
  {
    title: '序号',
    dataIndex: 'key',
    key: 'key',
    width: 100,
    render: (text, record, index) => `${index + 1}`,
  },
  {
    title: '操作类型',
    dataIndex: 'operTypeDesc',
    key: 'operTypeDesc',
    width: 100,
  },
  {
    title: '操作属性',
    dataIndex: 'operAttributeDesc',
    key: 'operAttributeDesc',
    width: 100,
  },
  {
    title: '变更前',
    dataIndex: 'beforeChange',
    key: 'beforeChange',
    width: 150,
  },
  {
    title: '变更后',
    dataIndex: 'afterChange',
    key: 'afterChange',
    width: 150,
  },

  {
    title: '操作人',
    dataIndex: 'createBy',
    key: 'createBy',
    width: 100,
  },
  {
    title: '最近更新时间',
    dataIndex: 'createTime',
    key: 'createTime',
    width: 160,
  },
];
const LogModal = React.memo(props => {
  const { visible, closeModal, logDataType, logDataId } = props;
  const [searchParams, setSearchParams] = useState({
    pageNum: 1,
    pageSize: 50,
  });
  const [totalNum, setTotalNum] = useState(0);
  const [loading, setLoading] = useState(false);
  const [dataSource, setDataSource] = useState([]);

  useEffect(() => {
    if (!visible) return;
    setLoading(true);
    getData({
      api: API_POST_SUPPLIER_DATA_LOG_PAGE,
      data: {
        ...searchParams,
        logDataId,
        logDataType,
      },
    })
      .then(res => {
        const {
          data: { data, totalNum },
        } = res;
        setDataSource(data || []);
        setTotalNum(totalNum);
        setLoading(false);
      })
      .catch(err => {
        setLoading(false);
      });
  }, [searchParams, visible]);

  const closeModalFun = () => {
    closeModal();
    setDataSource([]);
    setTotalNum(0);
  };

  // 页码改变
  const TableChange = (pagination, filter, sorter, extra) => {
    const { current, pageSize } = pagination;
    const params = {
      ...searchParams,
      pageNum: current,
      pageSize,
      searchType: '',
    };
    setSearchParams({ ...params });
  };

  const pagination = {
    total: totalNum,
    showTotal: (total, range) => `共 ${totalNum} 条`, // 显示总数
    showQuickJumper: true, // 是否可以快速跳转至某页
    current: searchParams.pageNum,
    pageSize: searchParams.pageSize,
    showSizeChanger: true, // 是否可以改变 pageSize
    className: 'pagination',
    onChange: TableChange,
    pageSizeOptions: ['50', '100', '200', '500'],
  };

  return (
    <Modal
      title="操作日志"
      visible={visible}
      width={1200}
      maskClosable={false}
      onCancel={closeModalFun}
      footer={<Button onClick={closeModalFun}>关闭</Button>}>
      <RecordForm
        loading={loading}
        setSearchParams={setSearchParams}
        searchParams={searchParams}
        logDataType={logDataType}
      />
      <Table
        columns={recordColumns}
        dataSource={dataSource}
        rowKey={record => `${record.id}`}
        loading={loading}
        pagination={pagination}
        onChange={TableChange}
        scroll={{ x: 'max-content', y: 700 }}
      />
    </Modal>
  );
});

export default LogModal;
